import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { ContactCase } from 'types/contacts'
import { PaymentsResponse } from 'types/payments'

export type PaymentInSidePanelBodyProps = {
  payment: PaymentsResponse
  contactCase: ContactCase
}

export const PaymentInSidePanelBody = ({ payment, contactCase }: PaymentInSidePanelBodyProps) => {
  const { t } = useTranslation()

  const paidCurrency = payment?.paidCurrency
  const walletCurrency = payment?.walletCurrency
  const exchangeRate = payment?.exchangeRate
  const address = payment?.address

  return (
    <Box flexCol gapY={12}>
      <DataListItem
        id="payment-in-amount-received"
        testId="payment-in-amount-received"
        title={t('transactions.sideBar.paymentInAmountReceived')}
        body={`${walletCurrency?.amount} ${walletCurrency?.currency}`}
      />
      <DataListItem
        id="payment-out-amount-paid"
        testId="payment-out-amount-paid"
        title={t('transactions.sideBar.paymentOutAmountPaid')}
        body={`${paidCurrency?.amount} ${paidCurrency?.currency}`}
      />
      <DataListItem
        id="paid-into-wallet"
        testId="paid-into-wallet"
        title={t('transactions.sideBar.paidIntoWallet')}
        body={`${payment?.merchantDisplayName}`}
      />
      <DataListItem
        id="exchange-rate"
        testId="exchange-rate"
        title={t('transactions.sideBar.exchangeRate')}
        body={`1 ${exchangeRate?.base} = ${exchangeRate?.rate} ${exchangeRate?.counter}`}
      />
      <DataListItem
        id="transaction-type"
        testId="transaction-type"
        title={t('transactions.sideBar.transactionType')}
        body={`${t('paymentIn')}`}
      />
      <DataListItem
        id="source-address"
        testId="source-address"
        title={t('transactions.sideBar.sourceAddress')}
        body={ellipseMiddleText(address?.address, 20, 10)}
        copyText={address?.address}
      />
      <DataListItem
        id="reference"
        testId="reference"
        title={t('transactions.sideBar.reference')}
        body={ellipseMiddleText(payment?.reference, 20, 10)}
        copyText={payment?.reference}
      />
      <DataListItem
        id="uuid"
        testId="uuid"
        title={t('transactions.sideBar.uuid')}
        body={ellipseMiddleText(payment?.uuid, 20, 10)}
        copyText={payment?.uuid}
      />
      <DataListItem
        id="hash"
        testId="hash"
        title={t('transactions.sideBar.hash')}
        body={ellipseMiddleText(contactCase?.hash, 20, 10)}
        copyText={contactCase?.hash}
      />
    </Box>
  )
}
